// The flag half of the session-detail path split. The pure mapping is
// `../../contracts/session-path`; this is the hook that resolves
// `release-scribe-enable-new-session-list` and hands the builder the boolean.
//
// WHY IT IS HERE NOW. The app-path version of this file said a flag is
// app-resolved by rule and therefore could not come behind the door. Ruling 36
// (2026-08-28, amended 2026-08-29) changed that for a domain's OWN flag:
// `useIsNewSessionListEnabled` is declared in `packages/session/src/flags.ts`
// beside its `defineFeatureFlag` descriptor, and package UI reads such a getter
// by RELATIVE import — never through `@heidi/session/flags`, because a package
// importing itself by name resolves through node_modules and reads as an
// undeclared external dependency.
//
// THE SPLIT ITSELF STANDS. `buildSessionPath` still takes the boolean as an
// argument, so a consumer that already resolves the flag — including one behind
// another door — asks the contract directly instead of mounting this hook.
import { useCallback } from 'react';
import { buildSessionPath } from '../../contracts/session-path';
import { useIsNewSessionListEnabled } from '../../flags';

/**
 * Returns a session-detail-path builder that honours the
 * `release-scribe-enable-new-session-list` flag. Centralises the route
 * mapping (`/scribe/sessions/:id` for the new list, `/scribe/session/:id`
 * for the legacy page) so callers don't repeat the flag-aware ternary.
 */
export const useBuildSessionPath = () => {
  const isNewSessionListEnabled = useIsNewSessionListEnabled();
  return useCallback(
    (sessionId: string): string => buildSessionPath(sessionId, isNewSessionListEnabled),
    [isNewSessionListEnabled]
  );
};
